module.exports = __webpack_public_path__ + "static/media/logo_juego_letra_M.74eb30a7.bin";